import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=473e81a1&scoped=true&"
import script from "./DueDate.vue?vue&type=script&lang=ts&"
export * from "./DueDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e81a1",
  null
  
)

export default component.exports